import { useContext } from "react"
import { ServerRenderedProps } from "./contexts/ServerRenderedProps"
import { Helmet } from "@dr.pogodin/react-helmet"
import { UIMatch, useMatches } from "react-router"

type SmartBannerHandle = {
  suppressOpenInAppBanner?: boolean
}

export function SmartBanner() {
  const { smart_banner: smartBanner } = useContext(ServerRenderedProps)
  const matches = useMatches() as UIMatch<unknown, SmartBannerHandle>[]

  if (!smartBanner?.app_enabled) return null

  const suppressBanner = matches.some(
    (match) => match.handle?.suppressOpenInAppBanner,
  )
  if (suppressBanner) return null

  return (
    <Helmet defer={false}>
      <meta
        name="apple-itunes-app"
        content={`app-id=1357742931, app-argument=${smartBanner.setup_url}`}
      />
    </Helmet>
  )
}
